import "src/pages/Reporting/Settings/components/DataStructure/DataPackageSlideout/QueryDetailTakeover/styles_vanilla.css.ts.vanilla.css!=!../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/pages/Reporting/Settings/components/DataStructure/DataPackageSlideout/QueryDetailTakeover/styles_vanilla.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA71WS3PaMBC-8yt2kukNZQzhkYhjZ3LLpfkFwl7bm8iSK4kA6fS_dyyD8KsktJlwYEC72u_bp_Zme2-35jmCXyOAUiQJqYzDdFbuViOAtYhfMqM3KmGxltpwuE6X6SKdV0IhKVOMHBaWg3UGXZyvRr9HN7XJiTeZkC2l2HMgJUkhSyXuGkpTrzQE4z-egzYJGmZEQhvL4e7AzJ9ymJQ7sFpSAtfpNJ2gv7KlxOUcJlH0rfpbYXKYVD8LUixHynLHIVo1-dXEamWWkMHYkVYcYi03haok-hVNKvWWQ05Jgqrhxm0_fPWXZxvUZl7t6OI8mqWzOGBujSg5VN-NG3N_oxAmI8Ukpu6Um8OhqZ0JGaujtdbO6WIwPMH2YijnQbpsS6OTU-dDGgzcNakHPosWyL3XaaUryMR7pRE0130rAEdKHatxbVXvmM1FUiWTlEUHrIpUBBFc4xxn2HQkeb9GW63gs2mdMG51iiBzuuSdcsDLuaSfzGUIPjoSCPAAb4xUckh5IJN9AZluLMaXksw7ddwcHkor7MKGs55bzghlS2FQuRaaN_lKltYkye0HxgMdEu1bs-7iRmP2kvzs1fvjBsDhzrGTAKWk0pL1My8nh8yWIsbKiXqO9Br10CRNtJcLukd-BTOAVCvHUlGQ3HPYECu00v7-GJ4eHrXS7AdmGynMGK6eHqA6uRrDIyqpx9U_EesxfNfKainsGML11cD0Db4V3re6RnND6qUdJtV-zo7PRavAY1QOTXX8vLGO0j2LtXKoHAePz9botlgHLKum_WGafiz4-pMZnEVtjf722Cov4vGvKD-_tAnMmWXl4yE-ibplFOJwfECPcTizaZ0GW2cFaj_U9v_KwjNFlaz6r30vfQHTnV0dNq01ZzldThYY2tq6vUQO5ISkZvu9Du5GQbxtI95OW4i7xoD9y044vEae2en29f7S2G4mi6iF-vaJqH8AzUio7YgLAAA\"}!../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var actionsCell = 'w9swrj9';
export var addFootnoteButtonWrapper = 'w9swrj1';
export var card = 'w9swrj2';
export var cardHeader = 'w9swrj3';
export var cardSubtitle = 'w9swrj4';
export var copyButton = 'w9swrjm';
export var dateRangeCell = 'w9swrjo';
export var dateRangeOffsetIcon = 'w9swrjr';
export var dateRangeText = 'w9swrjq';
export var emptyTabState = 'w9swrjw';
export var fieldTypeCell = 'w9swrjn';
export var footer = 'w9swrjs';
export var gridContainer = 'w9swrj7';
export var levelCell = 'w9swrjp';
export var mergeFieldCell = 'w9swrjk';
export var mergeFieldText = 'w9swrjl';
export var mutedHeading = 'w9swrjv';
export var nameCell = 'w9swrjb';
export var nameColumnHeader = 'w9swrjc';
export var nameColumnRightEdge = 'w9swrje';
export var nameColumnSingleCell = 'w9swrjd';
export var nameColumnSpanHeadCell = 'w9swrjf';
export var nameColumnSpanHeadCellView = 'w9swrjg';
export var nameColumnSpannedOverCell = 'w9swrjh';
export var nameText = 'w9swrjj';
export var noRowsOverlayIcon = 'w9swrj8';
export var pinnedActionsColumnCell = 'w9swrja';
export var placeholderText = 'w9swrju';
export var queryDetailTabs = 'w9swrj5';
export var queryPreviewGrid = 'w9swrjz';
export var queryPreviewLoading = 'w9swrjy';
export var settingsPanelBody = 'w9swrjt';
export var takeoverBody = 'w9swrj0';
export var toolbar = 'w9swrj6';
export var usageGrid = 'w9swrjx';
export var variantColumnDivider = 'w9swrji';